module.exports = __webpack_public_path__ + "img/onboarding_first_project.7fdd72a6.svg";